<template>

  <t-page>

    <t-page-form tabs :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle + ' - ' + form.name"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template>

        <t-form-tab title="Dados Básicos">

          <t-input v-model="form.typeEnvironmentId" hidden/>

          <t-input v-model="form.name" :add-error="error.name" label="Modelo de Ambiente" required/>

          <t-input v-model="form.color" color-reduced label="Cor"/>

          <b-form-checkbox v-if="isUpdate() && this.form.importedId > 0" class="col-sm-12 ml-2 mb-3" v-model="form.enableAutoImportedItems" switch>
            Permitir atualizações de itens relacionados ao modelo importado?
            <t-help
                title="Caso não desejar receber atualizações de itens para este modelo de ambiente, deixe desmarcado."/>
          </b-form-checkbox>

          <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

          <t-input-status v-model="form.status"/>

        </t-form-tab>

      </template>

      <template #out-of-form>

        <t-form-tab title="Itens" hash="item" lazy>
          <TypeEnvironmentItem :foreign-key="form.typeEnvironmentId"/>
        </t-form-tab>

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import TypeEnvironmentItem from "@/views/modules/place/TypeEnvironmentItem";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  components: {TypeEnvironmentItem},
  name: 'TypeEnvironmentForm',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      fieldKey: "typeEnvironmentId",
      form: {
        typeEnvironmentId: 0,
        typeEnvironmentNumber: 0,
        name: "",
        color: "",
        note: "",
        status: 1,
        enableAutoImportedItems: false,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      this.pageFormIsLoaded = true

    },

    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  }

}
</script>

